import React, { FC } from "react";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";

interface FormType {
    socialStatus: string;
    taxStatus: string;
    additionalTaxStatus: string;
    iNAMINumber: string;
    vatNumber: string;
}

type ProfessionFormProps = {
    isSubmittable?: boolean;
    personDetails: MyBrokerApi.PersonalDetails;
    onSubmit: (values: any) => void;
};

const defaultValues = (personDetails: MyBrokerApi.PersonalDetails) => {
    return {
        socialStatus: personDetails?.profession?.socialStatus?.id || "",
        taxStatus: personDetails?.profession?.taxStatus?.id || "",
        additionalTaxStatus: personDetails?.profession?.additionalTaxStatus?.id || "",
        iNAMINumber: personDetails?.profession?.inamiNumber,
    };
};

const formMapper = (formData: FormType) => {
    return {
        profession: {
            socialStatus: { id: formData.socialStatus },
            taxStatus: { id: formData.taxStatus },
            additionalTaxStatus: { id: formData.additionalTaxStatus },
            iNAMINumber: formData.iNAMINumber,
        },
    };
};

const ProfessionForm: FC<ProfessionFormProps> = ({ personDetails = null, isSubmittable = true, onSubmit }) => {
    const { t } = useTranslation();
    const {
        formState: { isDirty },
        control,
        handleSubmit,
    } = useForm<FormType>({
        mode: "onBlur",
        defaultValues: defaultValues(personDetails),
    });

    const submitHandler = (formData: FormType) => {
        onSubmit(formMapper(formData));
    };

    return (
        <form onSubmit={handleSubmit(submitHandler)}>
            <RefSelectInput name="socialStatus" control={control} table="socialStatuses" />
            <RefSelectInput
                name="taxStatus"
                control={control}
                label={t("User.PersonalDetails.Profession.TaxStatus")}
                disabled
                table="taxStatus"
            />
            <RefSelectInput name="additionalTaxStatus" control={control} disabled table="additionalTaxStatus" />
            <TextInput
                name="iNAMINumber"
                label={t("User.PersonalDetails.Profession.InamiNumber")}
                autoComplete="off"
                control={control}
                disabled
            />
            <Button disabled={!isDirty || !isSubmittable} type="submit" className="mt10" fullWidth>
                {t("User.PersonalDetails.Submit")}
            </Button>
        </form>
    );
};

export default ProfessionForm;
